import { render, staticRenderFns } from "./PublicDashboardShortLinkPage.vue?vue&type=template&id=72f7d904"
import script from "./PublicDashboardShortLinkPage.vue?vue&type=script&lang=js"
export * from "./PublicDashboardShortLinkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f7d904')) {
      api.createRecord('72f7d904', component.options)
    } else {
      api.reload('72f7d904', component.options)
    }
    module.hot.accept("./PublicDashboardShortLinkPage.vue?vue&type=template&id=72f7d904", function () {
      api.rerender('72f7d904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PublicDashboardShortLinkPage.vue"
export default component.exports